import { Button } from '@/components/ui/button'

const NUMBER_FORMATTER = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 })

export function MarketEvidenceUpdate({ update, onUseLatest, onKeepCurrent }) {
  if (!update) return null

  return (
    <div className="rounded-lg border border-primary/30 bg-primary/5 p-3">
      <p className="text-xs font-bold text-foreground">Market evidence updated</p>
      <p className="mt-1 text-xs text-muted-foreground">
        Latest suggested value: {formatEvidenceValue(update.suggestedValue, update.unit)}.
        {' '}Your adopted value of {formatEvidenceValue(update.adoptedValue, update.unit)} has not been changed.
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        <Button type="button" size="sm" onClick={() => onUseLatest?.(update)}>
          Use latest value
        </Button>
        <Button type="button" size="sm" variant="outline" onClick={() => onKeepCurrent?.(update)}>
          Keep adopted value
        </Button>
      </div>
    </div>
  )
}

function formatEvidenceValue(value, unit) {
  const number = Number(String(value ?? '').replaceAll(',', ''))
  if (!Number.isFinite(number)) return 'Unavailable'

  const formatted = NUMBER_FORMATTER.format(number)
  if (unit === 'GBP') return `£${formatted}`
  if (unit === 'GBP/month') return `£${formatted}/month`
  if (unit === 'GBP/week') return `£${formatted}/week`
  if (unit === 'GBP/ft2/year') return `£${formatted}/sqft/year`
  if (unit === 'GBP/ft2') return `£${formatted}/sqft`

  return `${formatted} ${unit ?? ''}`.trim()
}
